import React, { useState } from 'react';
import { Box, Grid, Text } from '@chakra-ui/react';
import { useGameColorsProvider } from '../../../providers/Theme/gameColorsProvider';
import { t } from 'i18next';

export const PanelGroup = ({
	children,
	isExpandable = false,
	...props
}: { children: React.ReactNode; isExpandable?: boolean } | any) => {
	const { backgroundColor } = useGameColorsProvider();

	const [isExpanded, setIsExpanded] = useState(!isExpandable);

	const toggleIsExpanded = () => {
		setIsExpanded(previousState => !previousState);
	};

	return (
		<Box
			width="100%"
			borderRadius={{ base: isExpandable ? '5px 5px 0 0' : '5px', hashup: '5px' }}
			border="2px solid rgba(128,128,128,0.3)"
		>
			<Grid
				p={{ base: '22px 24px' }}
				fontSize="12px"
				boxSizing="border-box"
				background={backgroundColor}
				borderRadius={{ base: isExpandable ? '3px 3px 0 0' : '3px', hashup: '3px' }}
				maxHeight={{ base: isExpanded ? 'unset' : '100px', hashup: 'unset' }}
				overflow="hidden"
				{...props}
			>
				{children}
			</Grid>
			<Box display={{ base: 'block', hashup: 'none' }}>
				{isExpandable && (
					<Text
						textTransform="uppercase"
						fontWeight="600"
						fontSize="8px"
						lineHeight="10px"
						letterSpacing=".4em"
						cursor="pointer"
						width="100%"
						textAlign="center"
						paddingY="8px"
						background={`${backgroundColor}80`}
						onClick={toggleIsExpanded}
					>
						{t(isExpanded ? 'gameOverview.collapse' : 'gameOverview.expand').toString()}
					</Text>
				)}
			</Box>
		</Box>
	);
};
